import { useRef } from 'react'
import { useTranslation } from 'react-i18next'

import { SIZE } from '../../../constants/size'
import { useDateLocale, useScreen, useTimeZone } from '../../../hooks'
import { FormModal } from '../../Form'
import { useResizeModal } from '../../Modal'

import {
  QA_NAME_VIEWING_FORM_MODAL,
  QA_NAME_VIEWING_FORM_SUBMIT,
} from './RentalPortalViewingFormModal.constants'
import { useViewingFormSubmit } from './RentalPortalViewingFormModal.hooks'
import { getViewingFormInitialValues } from './RentalPortalViewingFormModal.utils'
import { getViewingFormModalPayload } from './RentalPortalViewingFormModal.utils.payload'
import { getViewingFormValidationSchema } from './RentalPortalViewingFormModal.utils.validation'
import { RentalPortalViewingFormModalActions } from './RentalPortalViewingFormModalActions'
import { RentalPortalViewingFormModalFields } from './RentalPortalViewingFormModalFields'

function RentalPortalViewingFormModal({
  applicant,
  isBooking,
  listing,
  slot,
  start,
  onBooked,
  onClose,
  onCreated,
}) {
  const { t } = useTranslation()

  const locale = useDateLocale()
  const timezone = useTimeZone()

  const { isMobileScreenSize } = useScreen()

  const { fullScreen, handleResizeModal } = useResizeModal()

  const slotsReloadRef = useRef(null)

  const { handleSubmit } = useViewingFormSubmit({
    slotsReloadRef,
    onBooked,
    onClose,
    onCreated,
  })

  return (
    <FormModal
      Fields={RentalPortalViewingFormModalFields}
      containerProps={{
        boxSize: SIZE.LARGE,
        isFullScreen: isMobileScreenSize || fullScreen,
        qaName: QA_NAME_VIEWING_FORM_MODAL,
        onResize: isMobileScreenSize ? undefined : handleResizeModal,
      }}
      formBodyProps={{
        Actions: RentalPortalViewingFormModalActions,
        submitButtonText: 'RentalPortal.ViewingFormAddSlotSubmitKey',
        submitQaName: QA_NAME_VIEWING_FORM_SUBMIT,
        withNotifications: true,
      }}
      formFieldsProps={{ slotsReloadRef }}
      formTitle='RentalPortal.ViewingAddNewBtnKey'
      getPayload={getViewingFormModalPayload}
      initialValues={getViewingFormInitialValues({
        applicant,
        isBooking,
        listing,
        locale,
        slot,
        start,
        t,
        timezone,
      })}
      validationSchema={getViewingFormValidationSchema(t)}
      onClose={onClose}
      onSubmit={handleSubmit}
    />
  )
}

export default RentalPortalViewingFormModal
